import _ from 'lodash'
import TimeseriesProxy from '@/proxies/timeseries'
import Config from '@/config'
import moment from 'moment'

export default class ForecastLevelProxy {
  static get baseUrl () {
    return `${Config.apiBaseUrl}/data`
  }


  static fetchForecast(observationPoint, referenceEvent) {
    return new Promise((resolve, reject) => {
      let toFetch = []
      // Valeurs observées
      let headBslRemoteDatasource = observationPoint.datasources.find((datasource) => datasource.parameterType.code === 'HEAD_BSL' && datasource.datasourceType.code === 'remote')
      // Valeurs de prévisions
      let headForecast7Datasource = observationPoint.datasources.find((datasource) => datasource.parameterType.code === 'HEADS_FORECAST_7')
      let headForecast14Datasource = observationPoint.datasources.find((datasource) => datasource.parameterType.code === 'HEADS_FORECAST_14')
      let headForecast21Datasource = observationPoint.datasources.find((datasource) => datasource.parameterType.code === 'HEADS_FORECAST_21')

      // Les valeurs sont stockés à 00:00 UTC+1 (donc 23:00 UTC). L'aggregation temporelle "journalière" se fait en UTC en base de donnée.
      // Donc le timetamp à 23:00 UTC est compté pour le jour avant.
      let dateFrom = moment.utc(referenceEvent).subtract(1, 'days')
      // Ajout d'une minute car la borne toDate n'est pas comprise lors de l'extraction [fromDate; toDate[
      let dateTo = moment.utc(dateFrom).add(1, 'minutes')

      toFetch.push(TimeseriesProxy.extract({
        datasourceId: headBslRemoteDatasource.id,
        dateFrom: dateFrom.toISOString(),
        dateTo: dateTo.toISOString(),
        aggregationMode: 'dd'
      }))
      toFetch.push(TimeseriesProxy.extract({
        datasourceId: headForecast7Datasource.id,
        dateFrom: dateFrom.toISOString(),
        dateTo: dateTo.toISOString(),
        aggregationMode: 'dd'
      }))
      toFetch.push(TimeseriesProxy.extract({
        datasourceId: headForecast14Datasource.id,
        dateFrom: dateFrom.toISOString(),
        dateTo: dateTo.toISOString(),
        aggregationMode: 'dd'
      }))
      toFetch.push(TimeseriesProxy.extract({
        datasourceId: headForecast21Datasource.id,
        dateFrom: dateFrom.toISOString(),
        dateTo: dateTo.toISOString(),
        aggregationMode: 'dd'
      }))

      Promise.all(toFetch).then((data) => {
        let remoteValue  = _.head(data[0])
        let forecast7Value  = _.head(data[1])
        let forecast14Value = _.head(data[2])
        let forecast21Value = _.head(data[3])
        let toReturn = []

        // Calculs des dates des prévisions. Ajouter n jours suivant la source de données (7, 14, 21)
        // Les valeurs à afficher sont en UTC+1, suviant la remarque faite précédemment, il faut ajouter un jour de base pour retomber en UTC+1
        forecast7Value.event = moment.utc(forecast7Value.event).add(7 + 1, 'days').utcOffset(60, true).toISOString()
        forecast14Value.event = moment.utc(forecast14Value.event).add(14 + 1, 'days').utcOffset(60, true).toISOString()
        forecast21Value.event = moment.utc(forecast21Value.event).add(21 + 1, 'days').utcOffset(60, true).toISOString()
        toReturn = [forecast7Value, forecast14Value, forecast21Value]
        if (typeof remoteValue !== 'undefined') toReturn.unshift(remoteValue)
        resolve(toReturn)
      }).catch(reject)
    })
  }

}